/**
 * `.js-pagetop` クリックで先頭にスクロール。
 * Lenis が初期化されていれば lerp で滑らかに、なければネイティブ smooth scroll。
 */
export default class PageTop {
  constructor() {
    const buttons = document.querySelectorAll('.js-pagetop');
    if (!buttons.length) return;

    buttons.forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        this.scrollToTop();
      });
    });
  }

  scrollToTop() {
    if (window.__lenis && typeof window.__lenis.scrollTo === 'function') {
      window.__lenis.scrollTo(0, { duration: 1.2 });
      return;
    }
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({
      top: 0,
      behavior: reduceMotion ? 'auto' : 'smooth'
    });
  }
}
